import { useCallback, useRef } from "react";
import { _ROUTES } from "../../../utils/_routes_constants";
import { _ACTIONS } from "../../../utils/constants";
import { createToast, createToastOnLastItemSaved } from "../../../utils/toast";
import { DataService } from "../../../services/DataService";

/**
 * Hook useful to save the cell value in the grid
 * @param {Object} params - Contains site, fiscalYear, and version
 * @param {Function} setPendingRefresh - Function to refresh the data after modification
 * @returns {Function} Callback to handle cell changes
 */
export function useSaveOnCellChanged(params, setPendingRefresh) {
  const dataService = new DataService();
  const pendingUpdatesRef = useRef(0);

  return useCallback(
    async (agParams) => {
      const { colDef, data, newValue } = agParams;
      const { site, fiscalYear, version } = params;

      const fiscalMonth = parseInt(colDef.field);

      if (!site || !fiscalYear || !version) {
        createToast(
          "warning",
          "Données manquantes ou invalides. Vérifiez votre saisie.",
        );
        return;
      }

      const action = _ACTIONS.POST;
      const url = _ROUTES.SAVE_INPUT_SALE_TURNOVER_LRL;
      const base = {
        fiscalYear,
        version: version,
        site: site,
        source: data?.subThemes,
        theme: data?.theme,
      };
      let payload = base;

      /** @var isCurrentPrice check if the field is current price (first column) */
      const isCurrentPrice = colDef.field === "rate";

      if (isCurrentPrice) {
        payload = {
          ...base,
          sellingPrice: newValue,
        };
      } else {
        payload = {
          ...base,
          price: newValue,
          fiscalMonth: fiscalMonth,
        };
      }

      pendingUpdatesRef.current++;

      dataService.doRequest(action, url, payload).finally(() => {
        pendingUpdatesRef.current--;

        if (pendingUpdatesRef.current === 0) {
          setPendingRefresh((prev) => !prev);

          return createToastOnLastItemSaved(pendingUpdatesRef);
        }
      });
    },
    [params, setPendingRefresh],
  );
}
